<!-- eslint-disable max-len -->
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 23 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Annonce"
        transform="translate(-1010.000000, -351.000000)"
        :fill="color"
      >
        <g id="Photo" transform="translate(0.000000, 32.000000)">
          <g id="Photos" transform="translate(994.000000, 313.000000)">
            <g transform="translate(16.000000, 6.000000)">
              <ellipse
                id="Oval"
                cx="18.3173077"
                cy="7.41625"
                rx="1.34615385"
                ry="1.19"
              ></ellipse>
              <path
                d="M21.1057692,3.6975 L18.7019231,3.6975 L18.5096154,1.67875 C18.4375,0.78625 17.5480769,0.1275 16.5384615,0.19125 L1.82692308,1.25375 C0.817307692,1.3175 0.0721153846,2.125 0.144230769,3.0175 L1.05769231,12.85625 C1.10576923,13.28125 1.32211538,13.685 1.70673077,13.96125 C2.04326923,14.21625 2.45192308,14.34375 2.88461538,14.34375 C2.93269231,14.34375 2.98076923,14.34375 3.02884615,14.34375 L4.51923077,14.2375 L4.51923077,15.215 C4.51923077,16.1075 5.33653846,16.85125 6.37019231,16.85125 L21.1298077,16.85125 C22.1394231,16.85125 22.9807692,16.12875 22.9807692,15.215 L22.9807692,5.3125 C22.9567308,4.42 22.1394231,3.6975 21.1057692,3.6975 Z M21.5384615,5.3125 L21.5384615,9.6475 C20.9134615,9.6475 20.2884615,9.69 19.6394231,9.775 C17.5721154,10.03 15.6490385,10.71 14.2788462,11.645 C13.6057692,11.3475 12.9086538,11.05 12.1634615,10.81625 C10.0480769,10.115 7.93269231,9.7325 5.9375,9.66875 L5.9375,5.3125 C5.9375,5.1 6.12980769,4.93 6.37019231,4.93 L21.1298077,4.93 C21.3461538,4.95125 21.5384615,5.12125 21.5384615,5.3125 Z M2.90865385,13.09 C2.78846154,13.11125 2.69230769,13.06875 2.59615385,13.005 C2.5,12.94125 2.45192308,12.85625 2.45192308,12.75 L1.53846154,2.91125 C1.51442308,2.69875 1.68269231,2.52875 1.92307692,2.5075 L16.6346154,1.445 C16.875,1.42375 17.0673077,1.5725 17.0913462,1.785 L17.2596154,3.6975 L6.34615385,3.6975 C5.33653846,3.6975 4.49519231,4.42 4.49519231,5.33375 L4.49519231,12.98375 L2.90865385,13.09 Z M21.1057692,15.57625 L6.34615385,15.57625 C6.10576923,15.57625 5.91346154,15.40625 5.91346154,15.19375 L5.91346154,10.9225 C7.71634615,10.965 9.6875,11.32625 11.6346154,11.985 C12.4759615,12.26125 13.2692308,12.58 14.0144231,12.94125 C14.8317308,13.32375 15.625,13.77 16.3221154,14.25875 C16.4423077,14.34375 16.6105769,14.38625 16.7548077,14.38625 C16.9711538,14.38625 17.1634615,14.30125 17.3076923,14.1525 C17.5480769,13.87625 17.5,13.49375 17.1875,13.28125 C16.7067308,12.94125 16.1538462,12.64375 15.625,12.34625 C16.7548077,11.70875 18.2451923,11.24125 19.8317308,11.02875 C20.4086538,10.965 20.9615385,10.9225 21.5384615,10.9225 L21.5384615,15.215 C21.5384615,15.40625 21.3461538,15.57625 21.1057692,15.57625 Z"
                id="Shape"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
import props from "@/components/Icons/props";

export default {
  props: { ...props },
  name: "Photos",
};
</script>
